import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  titleContainer: {
    height: '7.29vh',
    background: themeColor.white,
    borderRadius: '2px',
    padding: '0 1.75vw',
  },
  titleText: {
    fontSize: rem(1.5),
    fontWeight: 500,
    letterSpacing: '0.25px',
    color: themeColor.defaultTextColor,
  },
}));
